// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nJ6g","comment":"styles_comment__fsuxM"};